import { lawconnect } from '../../api/lawconnect';
import { IframeWindow } from '.';

export class LawConnect implements lawconnect.Api {
  constructor(private iframe: IframeWindow) {}

  shareDocuments(request: lawconnect.ShareDocumentsRequest): void {
    this.iframe.postMessage({
      command: 'lawconnect.shareDocuments',
      args: request,
    });
  }

  shareFolder(request: lawconnect.ShareFolderRequest): void {
    this.iframe.postMessage({
      command: 'lawconnect.shareFolder',
      args: request,
    });
  }

  shareOfficeStatement(request: lawconnect.ShareOfficeStatementRequest): void {
    this.iframe.postMessage({
      command: 'lawconnect.shareOfficeStatement',
      args: request,
    });
  }

  shareTrustStatement(request: lawconnect.ShareTrustStatementRequest): void {
    this.iframe.postMessage({
      command: 'lawconnect.shareTrustStatement',
      args: request,
    });
  }
}
